"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var emptyReturn = {
  isValid: false,
  error: null,
  normalized: null,
  formatted: null,
  unformatted: null,
  telco: null,
  short: null,
  dashed: null,
  format: function format() {
    return "";
  }
};
exports.default = emptyReturn;